import { toast } from "sonner";

// Beep sintetico usando Web Audio API (nessun asset richiesto)
let ctx = null;
function beep(freq = 880, duration = 0.15) {
  try {
    if (typeof window === "undefined") return;
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.001, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.35, ctx.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.connect(gain).connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + duration);
  } catch { /* audio might be blocked */ }
}

/**
 * Se il prodotto ha stock_limit e stock_current impostati e la scorta corrente è ≤ soglia,
 * mostra un toast + suona un beep di attenzione.
 * Ritorna true se l'allarme è stato triggerato.
 */
export function checkStockAlert(product) {
  if (!product) return false;
  const limit = product.stock_limit;
  const current = product.stock_current;
  if (limit == null || current == null) return false;
  if (current <= 0) {
    beep(400, 0.25); setTimeout(() => beep(400, 0.25), 180);
    toast.error(`ESAURITO: ${product.name}`, {
      description: `Scorta a 0 · soglia minima ${limit}`,
      duration: 5000,
    });
    return true;
  }
  if (current <= limit) {
    beep(880, 0.18);
    toast.warning(`Scorta bassa: ${product.name}`, {
      description: `Rimanenza ${current} · soglia minima ${limit}`,
      duration: 4000,
    });
    return true;
  }
  return false;
}

export function beepOk() { beep(1200, 0.08); }
export function beepError() { beep(300, 0.25); setTimeout(() => beep(300, 0.25), 180); }
